import "./styles.css";

export default function CardHome({
  title,
  onClick,
  imgStyles,
  image,
  icon
}: any) {
  return (
    <article className="card" onClick={onClick}>
      <img
        className="card__background"
        src={image}
        alt={title}
        width="1920"
        height="2193"
        style={imgStyles}
      />
      <div className="card__content">
        {icon && <div className="card__icon">{icon}</div>}
        <h2 className="card__title">{title}</h2>
      </div>
    </article>
  );
}
